module.exports = __webpack_public_path__ + "img/investors.6318bf95.jpg";